import { Injectable } from '@angular/core';
import { ApiService, AuthService, UserService, AppContext } from './../shared';

@Injectable()
export class LoginService {
  public resendLoaderOn: boolean = false;

  constructor(private api: ApiService, private auth: AuthService, private user: UserService, private app: AppContext) {
  }

  validateEmail(control) {
    //let EMAIL_REGEXP = /^[-a-z0-9~!$%^&*_=+}{\'?]+(\.[-a-z0-9~!$%^&*_=+}{\'?]+)*@([a-z0-9_][-a-z0-9_]*(\.[-a-z0-9_]+)*\.(aero|arpa|biz|com|coop|edu|gov|info|int|mil|museum|name|net|org|pro|travel|mobi|[a-z][a-z])|([0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}))(:[0-9]{1,5})?$/i;
    //let EMAIL_REGEXP = /^[-a-z0-9~!$%^&*_=+}{\'?]+(\.[-a-z0-9~!$%^&*_=+}{\'?]+)*@([a-z0-9_][-a-z0-9_]*(\.[-a-z0-9_]+)*|\.(aero|arpa|biz|com|coop|edu|gov|info|int|mil|museum|name|net|org|pro|travel|mobi|[a-z][a-z])|([0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}))(:[0-9]{1,5})?$/i;
    //let EMAIL_REGEXP = this.app.EMAIL_REGEXP;
    let EMAIL_REGEXP = /^[-a-z0-9~!$%^&*_=+}{\'?]+(\.[-a-z0-9~!$%^&*_=+}{\'?]+)*@([a-z0-9_][-a-z0-9_]*(\.[-a-z0-9_]+)*|\.(aero|arpa|biz|com|coop|edu|gov|info|int|mil|museum|name|net|org|pro|travel|mobi|[a-z][a-z])|([0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}))(:[0-9]{1,5})?$/i;

    if (!EMAIL_REGEXP.test(control.value)) {
      return { invalidEmail: true };
    }
  }

  validatePassword(control) {
    // let PASSWORD_REGEXP = /^(?=.*[A-Z])(?=.*[a-z])(?=.*\d)(?=.*[!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?]).*$/;

    // if (!PASSWORD_REGEXP.test(control.value)) {
    //   return {invalidPassword: true};
    // }

    // disabled for the migration process
    let PASSWORD_REGEXP = /^(?![\s\S])/;

    if (PASSWORD_REGEXP.test(control.value)) {
      return { invalidPassword: true };
    }
  }

  login(email: string, password: string) {
    return new Promise((resolve, reject) => {
      this.auth.login(email, password).then(result => {
        resolve(result);
      }).catch(err => {
        this.handleError(err, email, password).then((message) => {
          reject(message);
        });
        // reject(this.handleError(err, email, password));
      });
    });
  }

  private handleError(error: any, email: string, password: string) {
    return new Promise((resolve, reject) => {
      try {
        let message: string = error.message.trim();

        if (message === 'User is not confirmed.') {
          // localStorage.setItem('email', email);
          // localStorage.setItem('password', password);

          resolve(message);
        } else if (message === 'Password reset required for the user') {
          // localStorage.setItem('email', email);

          this.user.checkIfUser(email).then((checkResult) => {
            // is a user
            // don't do anything
            resolve('Password reset required');
          }).catch((err) => {
            // is not a user
            this.api.destroy();
            this.user.confirmUser(email).then((confirmResult) => {
              this.auth.forgotPassword(email).then(result => {
                this.showMigrationMessage();
                resolve('');
              });
            }).catch((confirmError) => {
              resolve('please try again');
            });
          });
        } else {
          resolve(message);
        }
      } catch (ex) {
        resolve(error === 'object' ? error.message : '');
      }
    });
  }

  showMigrationMessage() {
    this.app.login = false;

    this.app.showMessage('Welcome to the new Linescape!',
      'We have migrated your account, but you will need to create a new password. Please check your email for a link to set your password.');
  }

  resendVerificationCode(email: string) {
    return new Promise((resolve, reject) => {
      this.auth.resendVerificationEmail(email).then(result => {
        resolve(result === 'SUCCESS');
      }).catch(err => reject(err));
    });
  }

  forgotPassword(email: string): Promise<any> {
    return new Promise((resolve, reject) => {
      this.auth.forgotPassword(email).then((forgotResult) => {
        // check if user
        this.user.checkIfUser(email).then((checkResult) => {
          // is a user
          resolve(forgotResult);
        }).catch((err) => {
          // is not a user
          this.api.destroy();
          this.user.confirmUser(email).then((confirmResult) => {
            this.showMigrationMessage();
            resolve(forgotResult);
          }).catch((confirmError) => {
          });
          // what should be done for the catch of confirmUser
        });
      }).catch((err) => {
        reject(err);
      });
    });
  }
}



// WEBPACK FOOTER //
// ./node_modules/angular-router-loader/src!./node_modules/angular2-template-loader!./node_modules/@angularclass/hmr-loader!./node_modules/tslint-loader!./src/app/login/login.service.ts